import * as React from "react";
import { InlineLoading, OverlayLoading } from "../common/index";

import "./SubControlLayout.scss";

interface ISubControlLayoutProps {
    loading?: boolean;
    saving?: boolean;
}

class SubControlLayout extends React.PureComponent<
    ISubControlLayoutProps,
    any
> {
    constructor(props) {
        super(props);
    }

    componentWillMount() {}

    componentWillReceiveProps(_nextProps: any) {}

    componentDidUpdate(_prevProps: any) {}

    componentWillUpdate(_nextProps: any) {}

    componentWillUnmount() {}

    render() {
        const { loading, saving } = this.props;

        return (
            <div
                className="container sub-control-container"
                style={{
                    position: loading ? "relative" : undefined,
                }}
            >
                {loading ? (
                    <InlineLoading absoluteCenter={true} size={40} />
                ) : (
                    <div>
                        {saving ? <OverlayLoading size={40} /> : null}
                        {this.props.children}
                    </div>
                )}
            </div>
        );
    }
}

export default SubControlLayout;
